(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cws-product-card-horizontal"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-form-cws')) {
    class ProductFormCWS extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('form');
        this.button = this.querySelector('button');
        this.form.addEventListener('submit', this.onSubmit.bind(this));
      }

      async onSubmit(event) {
        event.preventDefault();
        if (this.button.disabled) return;

        this.button.disabled = true;
        this.button.classList.add('is-loading');

        const formData = new FormData(this.form);
        formData.append('sections_url', window.location.pathname);

        try {
          const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: { Accept: 'application/json' },
            body: formData,
          });
          const data = await response.json();

          if (data.status) {
            console.error('CWS quick add error:', data.description || data.message);
            return;
          }

          try {
            const { CartUpdateEvent } = await import('@theme/events');
            const cart = await fetch(window.Shopify.routes.root + 'cart.js').then((r) => r.json());
            document.dispatchEvent(
              new CartUpdateEvent(cart, 'cws-product-card-h', { itemCount: cart.item_count, source: 'cws-product-card-h' })
            );
          } catch (nativeEventError) {
            document.dispatchEvent(
              new CustomEvent('cart:refresh', { bubbles: true, detail: { source: 'cws-product-card-h' } })
            );
          }

          const cartDrawer = document.querySelector('cart-drawer-component, cart-drawer, cart-notification');
          if (cartDrawer && typeof cartDrawer.open === 'function') {
            cartDrawer.open();
          } else if (cartDrawer && typeof cartDrawer.refresh === 'function') {
            cartDrawer.refresh();
          }
        } catch (error) {
          console.error('CWS quick add error:', error);
        } finally {
          this.button.disabled = false;
          this.button.classList.remove('is-loading');
        }
      }
    }

    customElements.define('product-form-cws', ProductFormCWS);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
